"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.voice.id': '语音ID',
};
